export default {
  name: 'postcode',
  type: 'action',
  isRequired: true
}
